module.exports = __webpack_public_path__ + "static/img/otsar-large.28f319b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank-logos/otsar-large.png
// module id = V+ql
// module chunks = 6